import { render, staticRenderFns } from "./EditSchoolForm.vue?vue&type=template&id=71a9fb3d&scoped=true&"
import script from "./EditSchoolForm.vue?vue&type=script&lang=js&"
export * from "./EditSchoolForm.vue?vue&type=script&lang=js&"
import style0 from "./EditSchoolForm.vue?vue&type=style&index=0&id=71a9fb3d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9fb3d",
  null
  
)

export default component.exports